// @flow

import * as React from 'react';

import classNames from '@ta/common.classnames';
import type { UxHints } from '@ta/social.shelf-items';

import styles from './HeaderSection.less';

type Props = {
  title: string,
  uxHints?: $ReadOnlyArray<UxHints>,
};

const HeaderSection = ({ title, uxHints }: Props) => {
  const separatedCluster = uxHints && uxHints.includes('SEPARATED_CLUSTER');

  return (
    <div
      className={classNames('h2', styles.section, { [styles.separated_cluster]: separatedCluster })}
    >
      {title}
    </div>
  );
};

HeaderSection.defaultProps = {
  uxHints: [],
};

export default HeaderSection;
